import axios from 'axios'
import config from "../../config"

let CheckInApi = {
  addWeight(model) {
    return axios.post(config.apiUrl + 'tracking/weight/checkIn/', model);
  },
  addHba1c(model) {
    return axios.post(config.apiUrl + 'tracking/hba1c/checkIn/', model)
  },
  addGoals(model) {
    return axios.post(config.apiUrl + 'tracking/goal/checkIn/', model)
  },
  getCheckInStatus() {
    return axios.get(config.apiUrl + 'tracking/checkIn/status/')
  }
};

export default CheckInApi;









// WEBPACK FOOTER //
// ./src/api/CheckIn/index.js